import CtaSection from '../../components/posa/CtaSection';
import PosaCardSuccessViewStyled from './PosaCardSuccessViewStyled';
import {PosaMessageProvider} from '../../context/PosaMessageContext';
import PosaRedeemStore from '../../stores/PosaRedeemStore';
import PropTypes from 'prop-types';
import React from 'react';
import StepsSlider from '../../components/posa/StepsSlider';
import SuccessHeader from '../../components/posa/SuccessHeader';
// import queryString from 'query-string';
import {connectToStores} from 'epic-alt-utils';
import {getSuccessData} from '../../utils';

/**
 * POSA Card Redeem View.
 */
@connectToStores
class PosaCardSuccessView extends React.Component {
  static propTypes = {
    posaRedeemStore: PropTypes.object,
    ctaAction: PropTypes.func,
    resetFlow: PropTypes.func,
    trackEvent: PropTypes.func,
    showBonusSection: PropTypes.bool,
  };
  static getStores() {
    return [PosaRedeemStore];
  }

  static getPropsFromStores() {
    return {
      posaRedeemStore: PosaRedeemStore.getState(),
    };
  }
  getCtaSection = () => {
    const {ctaAction, posaRedeemStore} = this.props;
    const {
      sections: {sections},
    } = posaRedeemStore.page;
    let ctaData = null;
    sections.forEach((section) => {
      for (const prop in section) {
        if (Object.hasOwn(section, prop)) {
          const data = section[prop];
          if (typeof data === 'object') {
            const {_type} = data;
            if (_type === 'POSA CTA Section') {
              ctaData = <CtaSection data={data} key={_type} ctaAction={ctaAction} />;
            }
          }
        }
      }
    });
    return ctaData;
  };
  getSuccess = () => {
    const {resetFlow, trackEvent, showBonusSection} = this.props;
    return (
      <SuccessHeader
        posaRedeemStore={this.props.posaRedeemStore}
        resetFlow={resetFlow}
        trackEvent={trackEvent}
        showBonusSection={showBonusSection}
      />
    );
  };
  getStepsSlider = () => {
    const successData = getSuccessData(this.props.posaRedeemStore);
    return <StepsSlider data={successData.sliderSection} />;
  };
  render() {
    const {
      redeemed,
      platform,
      page: {
        configs: {id},
        messages,
      },
    } = this.props.posaRedeemStore;
    if (!redeemed) return null;
    return (
      <PosaMessageProvider value={JSON.parse(messages)}>
        <PosaCardSuccessViewStyled
          className={`epic-code-redemption posaSuccessView ${platform}`}
          id={id}>
          {this.getSuccess()}
          {this.getStepsSlider()}
          {this.getCtaSection()}
        </PosaCardSuccessViewStyled>
      </PosaMessageProvider>
    );
  }
}

export default PosaCardSuccessView;
